import axios from "axios";
import { API_KEY } from "../constants/defaultUrl";
import {
  CRAWLING_NEWS_LIST_REQUEST,
  CRAWLING_NEWS_LIST_SUCCESS,
  CRAWLING_NEWS_LIST_FAIL,
} from "../constants/crawlingConstants";

export const getNewsList = () => async dispatch => {
  try {
    const keyword = "농산물";

    dispatch({ type: CRAWLING_NEWS_LIST_REQUEST });

    const { data } = await axios({
      method: "GET",
      url: `https://dapi.kakao.com/v2/search/blog?query=${keyword}`,
      headers: {
        Authorization: `KakaoAK ${API_KEY}`,
      },
    });

    const payload = data.documents;

    dispatch({
      type: CRAWLING_NEWS_LIST_SUCCESS,
      payload,
    });
  } catch (error) {
    dispatch({
      type: CRAWLING_NEWS_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
